export default __webpack_public_path__ + "static/media/photo--lg--misc-9.af11d24f.jpg";